var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { title: "New Seasonality", "hide-footer": "" },
      on: { hidden: _vm.resetForm },
      model: {
        value: _vm.localShow,
        callback: function ($$v) {
          _vm.localShow = $$v
        },
        expression: "localShow",
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Name")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: { placeholder: "e.g., Back to School, Holiday, Summer" },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [
            _vm._v("Description "),
            _c("span", { staticClass: "text-muted" }, [_vm._v("(optional)")]),
          ]),
          _vm._v(" "),
          _c("b-form-textarea", {
            attrs: {
              rows: "4",
              placeholder:
                "Describe what we should consider for this seasonal moment...",
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "outline-secondary" },
              on: {
                click: function ($event) {
                  _vm.localShow = false
                },
              },
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                variant: "primary",
                disabled: _vm.isSaving || !_vm.form.name.trim(),
              },
              on: { click: _vm.save },
            },
            [
              _vm.isSaving
                ? _c("b-spinner", { staticClass: "mr-1", attrs: { small: "" } })
                : _vm._e(),
              _vm._v("\n      Save Seasonality\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }